import React from "react";
import { ExternalLink } from "lucide-react";
import { navItems } from "../data/mock";

export const Footer = () => {
  const handleNavClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#060606] border-t border-white/[0.04]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a
              href="https://www.3dprintergear.com.au/3d-printers/formlabs/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2.5 mb-5"
            >
              <img
                src="/3dpg-logo.jpg"
                alt="3D Printer Gear"
                className="h-6 w-auto object-contain"
              />
              <span className="text-white/25 text-xs font-medium select-none">×</span>
              <img
                src="/formlabs-logo.png"
                alt="Formlabs"
                className="h-6 w-auto object-contain"
              />
            </a>
            <p className="text-white/35 text-sm leading-relaxed mb-4">
              Australia's authorised Formlabs SLA partner. Full showroom,
              expert team, and dedicated support since 2012.
            </p>
            <a
              href="https://www.3dprintergear.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-[#F76B1C] hover:text-[#FF8C42] text-sm font-medium transition-colors"
            >
              www.3dprintergear.com.au
              <ExternalLink size={12} />
            </a>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Sections</h4>
            <nav className="flex flex-col gap-2.5">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="text-white/35 hover:text-white/70 text-sm transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Printers */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Printers</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: "Form 4", url: "https://www.3dprintergear.com.au/formlabs-form-4-3d-printer" },
                { label: "Form 4B Medical", url: "https://www.3dprintergear.com.au/formlabs-form-4b-medical-3d-printer" },
                { label: "Form 4L Large", url: "https://www.3dprintergear.com.au/formlabs-form-4l-3d-printer" },
                { label: "Form 4BL Large Medical", url: "https://www.3dprintergear.com.au/formlabs-form-4bl-medical-3d-printer" },
                { label: "All Formlabs Products", url: "https://www.3dprintergear.com.au/3d-printers/shop-by-brand/formlabs/" },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/35 hover:text-white/70 text-sm transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Contact</h4>
            <div className="flex flex-col gap-2.5 text-sm">
              <a
                href="tel:1300334327"
                className="text-white/35 hover:text-white/70 transition-colors"
              >
                1300 334 327
              </a>
              <a
                href="mailto:admin@3dprintergear.com.au"
                className="text-white/35 hover:text-white/70 transition-colors"
              >
                admin@3dprintergear.com.au
              </a>
              <p className="text-white/25">
                781 High St, Reservoir VIC 3073
              </p>
              <p className="text-white/25">
                Mon–Fri 9–6 | Sat 10–4
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-white/[0.04] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/20 text-xs">
            © {new Date().getFullYear()} 3D Printer Gear. Australian owned
            and operated. Authorised Formlabs SLA Platinum Partner.
          </p>
          <a
            href="https://www.3dprintergear.com.au/3d-printers/formlabs/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/25 text-xs hover:text-white/40 transition-colors"
          >
            www.3dprintergear.com.au
          </a>
        </div>
      </div>
    </footer>
  );
};
